import { render, staticRenderFns } from "./MedicationTable.vue?vue&type=template&id=5db416d2&scoped=true"
import script from "./MedicationTable.vue?vue&type=script&lang=js"
export * from "./MedicationTable.vue?vue&type=script&lang=js"
import style0 from "./MedicationTable.vue?vue&type=style&index=0&id=5db416d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db416d2",
  null
  
)

export default component.exports